import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import login from '../pages/login/index.vue';
import changePassword from './../pages/login/change-password.vue'
import NotFound from "../404.vue"
import Welcome from "../pages/welcome/index.vue"
import factory from '../pages/configure/maintenance/factory.vue'
// import AboutView from '@/pages/AboutView.vue';
// @ts-ignore
import configure from './modules/configure.js'
// @ts-ignore
import diagnostics from './modules/diagnostics.js'
import home from '../pages/index.vue'
// @ts-ignore
import { useAuthStore, useMainStore, useUiStore } from '@/stores';
import { ElMessage } from 'element-plus';
// @ts-ignore
import { useWebSocketStore } from '@/stores/websocket';
// @ts-ignore
import { GET_REQUEST } from '../js/util'


const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/',
      redirect: '/login' // ✅ This will become /#/login due to hash mode
    },
    {
      path: '/change/password',
      component: changePassword
    },
    {
      path: '/welcome',
      component: Welcome
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404'
    },
    {
      path: '/404',
      component: NotFound,
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (About.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../pages/AboutView.vue'),
    // },
    {
      path: '/',
      component: home,
      name: '首页',
      // @ts-ignore
      iconCls: 'ion-speedometer',
      leaf: false,//只有一个节点
      children: [
        configure, 
        diagnostics,
        {
          path: 'factory-default',
          component: factory,
          hidden: true,
        },
      ]
    }
    
  ],
})

let query = GET_REQUEST();
if (query.token) sessionStorage.setItem('token', query.token);

router.beforeEach(async (to, from, next) => {
  const uiStore = useUiStore()
  requestAnimationFrame(() => {
    uiStore.startPageLoading()
  })
  next()
  ElMessage.closeAll(); // Close all Element UI messages

  const authStore = useAuthStore();
  const mainStore = useMainStore();
  const wsStore = useWebSocketStore()
  
  const restrictedPaths = ['/login', '/change/password', '/factory-default'];

  if (to.path === '/login') {
    sessionStorage.removeItem('token'); // Clear session on login
    authStore.logout(); // Update Pinia store
  }

  const isAuthenticated = sessionStorage.getItem('token') || authStore.isAuthenticated;

  if (!isAuthenticated && !restrictedPaths.includes(to.path)) {
    next({ path: '/login' }); // Redirect to login if not authenticated
  } else {
    if (to.path === '/login') {
      next();
    } else {
      try {
        const reload = sessionStorage.getItem('isReload') === 'true';
        if(!mainStore.unit && !wsStore.isReload){
          await authStore.queryStacking({ params: { loading: true } });
        }
      } catch (error) {
        console.error('queryStacking failed:', error);
      }
      next();
    }
  }
});

router.afterEach((to, from) => {
  if (to.path === '/login' && !['/login', '/'].includes(from.path)) {
    setTimeout(() => {
      uiStore.stopPageLoading()
      location.reload();
    });
  }
  const uiStore = useUiStore()
  requestAnimationFrame(() => {
    setTimeout(() => {
      uiStore.stopPageLoading()
    }, 10)
  })
});

// Fix for redundant navigation error in Vue 3
const originalPush = router.push;
router.push = function push(to) {
  return originalPush.call(this, to).catch(err => err);
};


export default router
